import {
    RECEIVE_TAX_CONSULTATION_FILES,
    REMOVE_TAX_CONSULTATION_FILE,
    REQUEST_TAX_CONSULTATION_FILES,
} from '../actions'
import { removeItemsById, updateOrAddItemsById } from '../helpers'

const initialState = {
    isFetching: null,
    fetchSuccessful: null,
    items: [],
}

export default (state = initialState, action) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_TAX_CONSULTATION_FILES:
            return { ...state, isFetching: true }

        case RECEIVE_TAX_CONSULTATION_FILES: {
            const items = updateOrAddItemsById({ currentItems: state.items, receivedItems: data.items })
            return { ...state, ...data, items, isFetching: false }
        }
        case REMOVE_TAX_CONSULTATION_FILE: {
            const items = removeItemsById({ currentItems: state.items, id: data.id })
            return { ...state, ...data, items, isFetching: false }
        }
        default:
            return state
    }
}
